<div adaptToolbarContent>
    <button adaptButtonIcon="add"
            [adaptBlockingClick]="addClient">Add approved client</button>
    <button adaptButtonIcon="refresh"
            [adaptBlockingClick]="loadClients">Refresh</button>
</div>

<div class="alert alert-info">
    Client ID Metadata Documents (CIMD) allow OAuth clients to describe and register themselves from an HTTPS URL.
    Without an approval boundary, an attacker could use a metadata document they control to obtain tokens for a signed-in user.
    Valid CIMD attempts are grouped by exact domain and remain unable to authorise while Pending.
    Approve only domains controlled by a trusted client provider: approval applies to all current and future CIMD URLs on
    that exact domain, but not its subdomains. OAuth grants, response type, scopes, resource permissions and PKCE
    requirements remain controlled by the server. Configuration-managed clients and domains may be restored when the
    server next starts.
</div>

@if (error) {
    <div role="alert"
         class="alert alert-danger">{{ error }}</div>
}

<dx-data-grid [dataSource]="clients"
              [allowColumnReordering]="true"
              [allowColumnResizing]="true"
              [columnAutoWidth]="true"
              [rowAlternationEnabled]="true"
              [wordWrapEnabled]="true"
              keyExpr="ClientId">
    <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
    <dxo-data-grid-group-panel [visible]="true"></dxo-data-grid-group-panel>
    <dxo-data-grid-grouping [autoExpandAll]="true"></dxo-data-grid-grouping>
    <dxi-data-grid-column dataField="DisplayName"
                          caption="Client name"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="ClientId"
                          caption="Client ID"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="Type"
                          caption="Type"
                          [groupIndex]="0"></dxi-data-grid-column>
    <dxi-data-grid-column caption="Approval"
                          cellTemplate="approvalTemplate"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="RedirectUris"
                          caption="Redirect URIs"
                          cellTemplate="redirectUrisTemplate"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="IsConfigurationManaged"
                          caption="Source"
                          cellTemplate="managedByTemplate"></dxi-data-grid-column>
    <dxi-data-grid-column caption="Actions"
                          cellTemplate="actionsTemplate"
                          [allowFiltering]="false"
                          [allowSorting]="false"></dxi-data-grid-column>

    <div *dxTemplate="let item of 'redirectUrisTemplate'">
        @for (uri of item.data.RedirectUris; track uri) {
            <div><code>{{ uri }}</code></div>
        }
    </div>

    <div *dxTemplate="let item of 'managedByTemplate'">
        @if (item.data.IsConfigurationManaged) {
            Configuration
        } @else if (item.data.IsClientMetadataDomain && !item.data.IsApproved) {
            Client attempt
        } @else {
            Administration page
        }
    </div>

    <div *dxTemplate="let item of 'approvalTemplate'">
        {{ item.data.IsApproved ? "Approved" : "Pending" }}
    </div>

    <div *dxTemplate="let item of 'actionsTemplate'">
        @if (item.data.IsClientMetadataDomain && !item.data.IsApproved) {
            <button adaptButtonIcon="fal fa-check"
                    [adaptBlockingClick]="approveClientMetadataDomain"
                    [adaptBlockingClickParam]="item.data">Approve domain</button>
        }
        @if (!item.data.IsClientMetadataDomain) {
            <button adaptButtonIcon="edit"
                    [adaptBlockingClick]="editClient"
                    [adaptBlockingClickParam]="item.data">Edit</button>
        }
        @if (!item.data.IsClientMetadataDomain || item.data.IsApproved) {
            <button adaptButtonIcon="delete"
                    [adaptBlockingClick]="deleteClient"
                    [adaptBlockingClickParam]="item.data">Remove</button>
        }
    </div>
</dx-data-grid>
